import { Platform } from "react-native";
import styled from "styled-components/native";
import { dimenHeight } from "shared-components/src/utils/helper";
import FastImage from "react-native-fast-image-web-support";

export default styled(FastImage)`
  flex: 1;
  height: ${Platform.OS === "web" ? "88" : dimenHeight(136)}px;
  border-radius: 4px;
  margin-horizontal: 8px;
`;
